const tableTitleAreas = {
  title: 'Departamentos',
  placeholder: 'Pesquisar por departamento'
}

export default tableTitleAreas;
